"use client";
import { useTranslations } from "next-intl";
import { Skeleton } from "@radix-ui/themes";
import { DataInputParams } from "./inputType";
import { Form, Switch, Skeleton as AntSkeleton } from "antd";
import { Debug } from "@/util/debug";
import { checkDisabled, checkNoItem, GetDataInputElement } from "./inputFunction";
import SkeletonInput from "antd/es/skeleton/Input";

export default function DataSwitch(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  const placeholder = params.placeholder ?? params.defaultValue ?? params.value;
  const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
  const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;
  const unitPrev = params.unitPrev ? GetDataInputElement(params.unitPrev, false, params.values, t) : undefined;
  const unit = params.unit ? GetDataInputElement(params.unit, true, params.values, t) : undefined;
  //Debug(params);
  //const disabled = params.inputMode == "read" ? true : params.disabled;
  const disabled = checkDisabled(params);
  const checked = params.value ?? params.defaultValue;
  const checkedProp = params.inputMode == "view" ? { checked: checked } : { checked: checked };
  const checkedChildren = params.switchProp?.checkedChildren
    ? typeof params.switchProp.checkedChildren == "string" && params.transition
      ? t(params.switchProp.checkedChildren)
      : params.switchProp.checkedChildren
    : undefined;
  const unCheckedChildren = params.switchProp?.unCheckedChildren
    ? typeof params.switchProp.unCheckedChildren == "string" && params.transition
      ? t(params.switchProp.unCheckedChildren)
      : params.switchProp.unCheckedChildren
    : undefined;
  const getInput = () => {
    return (
      <Switch
        {...params.switchProp}
        className={params.inputClassName}
        id={params.name}
        loading={params.loading ?? false}
        disabled={disabled}
        checkedChildren={checkedChildren}
        unCheckedChildren={unCheckedChildren}
        onChange={(e) => {
          // Debug(e);
          if (params.onChange) {
            params.onChange({ key: params.name, value: e, index: params.index, name: params.subListName });
          }
        }}
        {...checkedProp}
      />
    );
  };
  return (
    <>
      {prev}
      {unitPrev}
      {checkNoItem(params) ? (
        getInput()
      ) : (
        <Form.Item
          name={params.name}
          noStyle
          valuePropName="checked"
          initialValue={checked}
          required={params.required}
          onMetaChange={(e) => {
            Debug(e);
          }}
        >
          {getInput()}
        </Form.Item>
      )}
      {unit}
      {next}
    </>
  );
}
